import React from 'react';
import { StyleSheet } from 'react-native';
import { MBButton, MBButtonProps } from './MBButton';

const styles = StyleSheet.create({
  capWidth: {
    width: '100%',
    maxWidth: 320,
    alignSelf: 'center',
  },
});

export function MBButtonCappedWidth(props: MBButtonProps) {
  return <MBButton {...props} style={styles.capWidth} />;
}
